// extracted by mini-css-extract-plugin
export default {"image_ig":"Image__image_ig--ig-vhgZ4","loaded_ig":"Image__loaded_ig--ig-FoDmn"};